import { render, staticRenderFns } from "./CaseSummaryCard.vue?vue&type=template&id=8db763ee&"
import script from "./CaseSummaryCard.vue?vue&type=script&lang=js&"
export * from "./CaseSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports